document.addEventListener('DOMContentLoaded', function() {
  const productHandle = 'phone-tomb-plastic'; // Your product handle
  const downloadUrl = 'https://github.com/user-attachments/files/23426180/Phone.Tomb.3D.Printable.zip'; // UPDATE after attaching files!

  // Only run on this product page
  if (!window.location.pathname.includes('/products/' + productHandle)) return;

  // Find Add to Cart button (Horizon-compatible selectors)
  const addToCartButton = document.querySelector('[data-add-to-cart]') ||
                         document.querySelector('button[name="add"]') ||
                         document.querySelector('.product-form__cart-submit');

  if (!addToCartButton) return;

  // Get container and clear original buttons
  const container = addToCartButton.closest('.product-form__buttons') || 
                   addToCartButton.closest('div') || 
                   addToCartButton.parentElement;
  if (!container) return;
  container.innerHTML = '';

  // Create Download button
  const downloadBtn = document.createElement('a');
  downloadBtn.href = downloadUrl;
  downloadBtn.target = '_blank';
  downloadBtn.rel = 'noopener noreferrer';
  downloadBtn.textContent = 'Download Files';
  downloadBtn.className = 'button button--full-width'; // Matches Horizon's button styles
  downloadBtn.style.cssText = `
    background-color: #28a745 !important;
    color: white !important;
    text-align: center;
    font-weight: 600;
    border-radius: 6px;
    text-decoration: none;
    padding: 1rem;
    display: block;
    font-size: 1rem;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s ease; // Horizon-like hover
  `;
  downloadBtn.addEventListener('mouseenter', function() { this.style.backgroundColor = '#218838'; });
  downloadBtn.addEventListener('mouseleave', function() { this.style.backgroundColor = '#28a745'; });
  downloadBtn.setAttribute('aria-label', 'Download free 3D CAD files for Phone Tomb (Plastic)');

  // Add CC-BY-4.0 license note
  const note = document.createElement('p');
  note.innerHTML = 'Free under <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" style="color: #28a745; text-decoration: underline;">CC-BY-4.0</a> license – Credit: Sorenandflying1';
  note.style.cssText = 'margin: 0.75rem 0 0; font-size: 0.875rem; color: #666; text-align: center; line-height: 1.4;';

  // Insert into container
  container.appendChild(downloadBtn);
  container.appendChild(note);

  // Update price to "FREE" (optional)
  const priceElement = document.querySelector('.price, .product__price');
  if (priceElement) {
    priceElement.innerHTML = '<span class="price-item price-item--regular">FREE</span>';
    priceElement.style.color = '#28a745';
    priceElement.style.fontWeight = '600';
  }

  // Hide dynamic checkout buttons (e.g., Shop Pay)
  const dynamicButtons = document.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]');
  dynamicButtons.forEach(btn => btn.style.display = 'none');
});